export default {
      id: "icon--coaching-usage",
      viewBox: "0 0 30 19",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--coaching-usage",
      toString: function () {
        return this.url;
      }
    }